/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

/**
 * The decision to record. unreviewed clears an earlier one.
 */
export const SetAIToolDecisionRequestBodyDecision = {
  Unreviewed: "unreviewed",
  Approved: "approved",
  Blocked: "blocked",
} as const;
/**
 * The decision to record. unreviewed clears an earlier one.
 */
export type SetAIToolDecisionRequestBodyDecision = ClosedEnum<
  typeof SetAIToolDecisionRequestBodyDecision
>;

export type SetAIToolDecisionRequestBody = {
  /**
   * The decision to record. unreviewed clears an earlier one.
   */
  decision: SetAIToolDecisionRequestBodyDecision;
  /**
   * Why the decision was made. Shown beside it and carried into the audit trail.
   */
  rationale?: string | undefined;
  /**
   * Id of the detection target to decide on, as agents report it.
   */
  targetId: string;
};

/** @internal */
export const SetAIToolDecisionRequestBodyDecision$outboundSchema: z.ZodMiniEnum<
  typeof SetAIToolDecisionRequestBodyDecision
> = z.enum(SetAIToolDecisionRequestBodyDecision);

/** @internal */
export type SetAIToolDecisionRequestBody$Outbound = {
  decision: string;
  rationale?: string | undefined;
  target_id: string;
};

/** @internal */
export const SetAIToolDecisionRequestBody$outboundSchema: z.ZodMiniType<
  SetAIToolDecisionRequestBody$Outbound,
  SetAIToolDecisionRequestBody
> = z.pipe(
  z.object({
    decision: SetAIToolDecisionRequestBodyDecision$outboundSchema,
    rationale: z.optional(z.string()),
    targetId: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      targetId: "target_id",
    });
  }),
);

export function setAIToolDecisionRequestBodyToJSON(
  setAIToolDecisionRequestBody: SetAIToolDecisionRequestBody,
): string {
  return JSON.stringify(
    SetAIToolDecisionRequestBody$outboundSchema.parse(
      setAIToolDecisionRequestBody,
    ),
  );
}
